<soft-page>
  <soft-page-header>
    <ng-container *ngTemplateOutlet="header()?.template() ?? null"></ng-container>
  </soft-page-header>
  <soft-resource-container [resource]="resource()">
    <ul class="flex flex-col gap-2 my-4">
      <li
        *ngFor="let item of resource().value()"
        [ngClass]="itemClick.observed ? 'cursor-pointer' : ''"
        (click)="itemClick.emit(item)"
      >
        @if (itemTemplate(); as itemTemplate) {
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { item: item }"
          ></ng-container>
        } @else {
          No-Template:
          {{ item | json }}
        }
      </li>
    </ul>
    @if (summary(); as summary) {
      @if (summary.template(); as summaryTemplate) {
        <ng-container *ngTemplateOutlet="summaryTemplate"></ng-container>
      }
    }
  </soft-resource-container>
  <ng-content></ng-content>
</soft-page>
